import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.grayscale[100]};
  padding-bottom: 15px;

  header {
    margin: 0 auto;
    width: 70%;
    max-width: 100%;

    @media (max-width: 768px) {
      width: 90%;
    }

    a {
      padding: 30px 0 15px 0;
    }
  }

  h1 {
    color: #0160cf;
    display: block;
    font-size: 2em;
    line-height: normal;
    font-weight: 700;

    @media (max-width: 768px) {
      font-size: 1.6em;
    }

    span {
      font-weight: 300;
    }
  }

  h2 {
    color: #0160cf;
    font-weight: 600;
    font-size: 1em;
    margin-bottom: 1em;
  }

  ul {
    padding: 0;
    list-style-type: none;
    font-size: 1rem;
    line-height: 1.5rem;

    @media (min-width: 1200px) {
      max-width: 65%;
    }

    li {
      &:not(:last-child) {
        margin-bottom: 1em;
      }
    }
  }

  .disclaimer {
    font-size: 0.7em;
    line-height: 1.5em;
    padding-top: 1.2em;
    text-align: left;
  }
`;

export const Wrapper = styled.section`
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.grayscale[110]};
  ${({ theme }) => theme.typography.normal};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  margin: 0 auto;
  width: 70%;
  max-width: 100%;
  padding: 5em 8em;
  display: flex;
  flex-direction: column;
  gap: 36px;

  @media (max-width: 1000px) {
    padding: 3em 5em;
  }

  @media (max-width: 768px) {
    padding: 1em 2em;
    width: 90%;
  }
`;

export const Footer = styled.footer`
  text-align: center;

  small {
    display: block;
    font-size: 0.625rem;
    margin-top: 40px;
  }
`;

export const CreditsList = styled.ul`
  margin: 16px 0;
`;

export const AdditionalInfoContainer = styled.div`
  border-top: 1px solid #D6D6D6;
  padding: 16px 0;

  h3, p {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;
